export default function parseInteger(string){
    return parseInt(string, 10)
}